import React, { useRef, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PrintPdf from '../PrintPdf';
import { generatePdfFromElement } from '../../utils/generatePdf';

const AdminPrintView = () => {
    const { formId } = useParams();
    const printRef = useRef(null);

    const [pdfUrl, setPdfUrl] = useState(null);
    const [ready, setReady] = useState(false);

    // 1️⃣ Update localStorage FIRST
    useEffect(() => {
        if (!formId) return;

        // clear previous state
        setPdfUrl(null);
        setReady(false);

        localStorage.setItem('sID', formId);

        // confirm localStorage updated
        const stored = localStorage.getItem('sID');
        if (stored === formId) {
            setReady(true);
        }
    }, [formId]);

    // 2️⃣ Generate PDF ONLY AFTER PrintPdf renders
    useEffect(() => {
        if (!ready) return;

        const timer = setTimeout(async () => {
            if (!printRef.current) return;

            const pdf = await generatePdfFromElement(printRef.current);
            const blob = pdf.output('blob');
            const url = URL.createObjectURL(blob);

            setPdfUrl(url);
        }, 1200); // wait for API + render

        return () => clearTimeout(timer);
    }, [ready]);

    return (
        <div style={{ padding: '15px', background: '#fff' }}>

            {/* ACTION BUTTON */}
            <div style={{ display: 'flex', gap: '12px', marginBottom: '12px' }}>
                {pdfUrl && (
                    <a
                        href={pdfUrl}
                        download={`Application_${formId}.pdf`}
                        className="btn btn-success"
                    >
                        ⬇️ Download PDF
                    </a>
                )}
            </div>

            {/* HIDDEN RENDER TARGET (ONLY WHEN READY) */}
            {ready && (
                <div style={{ position: 'absolute', left: '-9999px', top: 0 }}>
                    <div ref={printRef}>
                        <PrintPdf />
                    </div>
                </div>
            )}

            {/* PDF PREVIEW */}
            {pdfUrl ? (
                <iframe
                    src={pdfUrl}
                    title="Application PDF"
                    style={{
                        width: '100%',
                        height: '90vh',
                        border: '1px solid #ccc'
                    }}
                />
            ) : (
                <div style={{ padding: '40px', textAlign: 'center' }}>
                    Generating PDF, please wait...
                </div>
            )}
        </div>
    );
};

export default AdminPrintView;
